import React from 'react';
import { factoryExpenseListMeta } from '../../constants/factoryExpenseCategories';
import { EXPENSE_CATEGORY_VALUES } from '../../constants/expenseCategories';
import { useLanguage } from '../../i18n/LanguageContext';
import ExpenseCategoryList from './ExpenseCategoryList';

const EmployeeExpenses = ({ user, onAddExpense }) => {
  const { t, lang } = useLanguage();
  const meta = factoryExpenseListMeta(EXPENSE_CATEGORY_VALUES.STAFF, user, lang);
  return (
    <ExpenseCategoryList
      user={user}
      category="staff"
      title={meta?.title || t('exp.list.staff.title')}
      lede={meta?.lede || t('exp.list.staff.lede')}
      onAddExpense={onAddExpense}
    />
  );
};

export default EmployeeExpenses;
